'use strict';
import { EwSiteApp } from '../../app/ewsiteapp';

EwSiteApp.requires.push('ui.bootstrap');

EwSiteApp.controller('IndicatorsCategoryCtrl', [
	'$scope',
	'$http',
	'$filter',
	'$uibModal',
	'$log',
	function ($scope, $http, $filter, $uibModal, $log) {
		$scope.isEdit = false;
		$scope.dataUrl = '';
		$scope.storeUrl = '';
		$scope.companies = [];
		$scope.filter = {company_id: '0'};
		$scope.messages = [];

		$scope.loadData = function () {
			if ($scope.dataUrl !== '') {
				$http.get($scope.dataUrl)
						.then(function (response) {
							var data = response.data;
							if (typeof data.success !== 'undefined') {
								if (data.canedit) {
									$scope.isEdit = true;
								}
								if (data.success) {
									$scope.companies = data.companies;
								}
							}
						})
						.catch(function (err) {
							$log.error('Failed to load dataUrl:', err);
						});
			}
		};

		$scope.getFiltered = function () {
			if ($scope.filter.company_id > 0) {
				return $filter('filter')($scope.companies, {id: $scope.filter.company_id}, true);
			}
			return $scope.companies;
		};

		$scope.edit = function (item) {
			if (!$scope.isEdit) {
				return null;
			}

			var modalInstance = $uibModal.open({
				templateUrl: 'indicators/editdata.html',
				controller: 'IndicatorsCompanyEditCtrl',
				size: 'lg',
				resolve: {
					item: function () {
						return item;
					}
				}
			});

			modalInstance.result.then(function (result) {
				if ($scope.storeUrl !== '') {
					$http({
						method: 'POST',
						url: $scope.storeUrl,
						data: result,
						xsrfCookieName: secure_xsrf_name,
						xsrfHeaderName: 'X-' + secure_xsrf_name
					})
							.then(function (response) {
								var data = response.data;
								if (data.success && !angular.isUndefined(data.item)) {
									angular.extend(item, data.item);
								} else {
									if (data.message) {
										$scope.storeError(data.message);
									}
								}
								if (data.debug) {
									$log.debug(data.debug);
								}
							})
							.catch(function (err) {
								$log.error('Failed to store data:', err);
								$scope.storeError('Failed to save changes.');
							});
				} else {
					$log.warn('No URL! url_template: ' + $scope.storeUrl);
				}
			});
		};

		$scope.storeError = function (message) {
			$scope.messages.push(message);
		};

		$scope.clearMessages = function () {
			$scope.messages = [];
		};
	}
]);

EwSiteApp.controller('IndicatorsCompanyEditCtrl', [
	'$scope',
	'$uibModalInstance',
	'item',
	function ($scope, $uibModalInstance, item) {
		$scope.item = angular.copy(item);

		$scope.save = function () {
			$uibModalInstance.close($scope.item);
		};
		$scope.cancel = function () {
			for (var i in $scope.require) {
				if ($scope.require.hasOwnProperty(i)) {
					$scope.require[i] = false;
				}
			}
			$uibModalInstance.dismiss();
		};
	}
]);
